import { userWithMerchantToken, userWithoutToken, userWithUserToken } from '@lib/api/v2';

interface RegisterData {
  merchantId: number;
  password: string;
  phoneNum: string;
  gender: 0 | 1;
  parentPhoneNum: string;
  name: string;
  email: string;
  job: string;
  smsDeny: boolean;
  alertKaKaoToggle: boolean;
}

/**
 * 사용자가 이용 중인 지점 목록
 * @returns
 */
export const getMerchant = () => userWithUserToken.get(`/merchant`);

/**
 * 사용자 정보 조회
 * @returns
 */
export const getInfo = () => userWithMerchantToken.get('/info');

/**
 * 사용자 회원가입 (v2)
 * @param registerData
 * @returns
 */
export const postRegister = (registerData: RegisterData) =>
  userWithoutToken.post(`/register`, registerData);

/**
 * 회원 바코드 재발급 + 바코드 링크 문자 발송 (점주)
 * @param phoneNum 회원 휴대폰번호
 */
export const postSendUserBarcode = (phoneNum: string) =>
  userWithMerchantToken.post('/qrCode', { phoneNum });

/**
 * 회원 PIN 번호 재설정 (점주가 새 6자리 PIN 직접 입력)
 * @param phoneNum 회원 휴대폰번호
 * @param pinNum 숫자 6자리
 */
export const patchResetUserPin = (phoneNum: string, pinNum: string) =>
  userWithMerchantToken.patch('/pinNum/reset', { phoneNum, pinNum });

/**
 * 회원 얼굴 등록 정보 조회 (점주)
 * @param phoneNum 회원 휴대폰번호
 * @returns { hasFace, faceImg, createdAt }
 */
export const getUserFace = (phoneNum: string) =>
  userWithMerchantToken.get('/face', { params: { phoneNum } });

/**
 * 회원 얼굴 삭제 (점주)
 * @param phoneNum 회원 휴대폰번호
 */
export const deleteUserFace = (phoneNum: string) =>
  userWithMerchantToken.delete('/face', { data: { phoneNum } });

/**
 * 회원 데이터 통합 리포트 (마이그레이션 검증용 엑셀 원천) — LETMEUP-409
 * 회원 1행: 기본정보 + 현재 좌석 이용권 + 사물함 + 결제합계 (백엔드에서 한글 키로 가공)
 * @param merchantId 지점 ID
 */
export const getMemberMigrationReport = (merchantId: number) =>
  userWithMerchantToken.get(`/migration-report/${merchantId}`);
